<template>
  <div>
    <ModalBase title="Login"
               @close-modal="closeModal"
               @proceed="login"
               ctaProceed="Login">
      <div v-if="errors">
        <div class="p-3 mb-2 bg-danger text-white" v-for="error in errors[0]">
          <p><strong>{{ error.title }}</strong></p>
          <p>{{ error.detail }}</p>
        </div>
      </div>

      <div class="login-wrapper">
        <form @submit.prevent="login">
          <div class="form-group">
            <label for="email-input">Email address</label>
            <input type="email" v-model="email" class="form-control" id="email-input">
          </div>
          <div class="form-group">
            <label for="password-input">Password</label>
            <input type="password" v-model="password" class="form-control" id="password-input">
          </div>
          <input class="hidden-submit" type="submit">
        </form>
      </div>
    </ModalBase>
  </div>

</template>

<script>
  import { EventBus } from '../../lib/event-bus.js';
  import ModalBase from "./ModalBase";
  import { HTTP } from '../../lib/http';

  export default {
    name: "LoginModal",
    props: {
    },
    components: {
      ModalBase
    },
    methods: {
      closeModal() { this.$emit('close-modal', true); },

      login() {
        this.errors = [];
        let data = {
          email: this.email,
          password: this.password
        };

        HTTP.post('/authenticate', { data: data })
          .then((response)=> {
            localStorage.setItem('token', response.data.data.authToken);
            localStorage.setItem('username', response.data.data.username);
            EventBus.$emit('logged-in', true);
            this.closeModal();
            vm.$forceUpdate();
          })
          .catch(err => {
            this.errors = [err.response.data.errors];
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            EventBus.$emit('logged-in', false);
          })
      }
    },
    computed: {},
    beforeMount() {},
    data() {
      return {
        email: null,
        password: null,
        errors: null
      };
    },
  };
</script>

<style scoped lang="scss">
  @import "../../../src/assets/scss/variablesx";
  .hidden-submit {
    display: none;
  }
</style>
